export default from './CookiesPolicy';



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/CookiesPolicy/index.js